module.exports = __webpack_public_path__ + "static/media/undraw_choose_80qg.ffc05149.svg";